import styled from '@emotion/styled';
import colors from '../styles/colors';

export const Body5 = styled.h4`
  font-family: Mulish-Regular;
  color: ${colors.darkNavy};
  font-size: 12.5px !important;
  line-height: 17px !important;
`;
